import { Front, Angular, React, coding } from "../../utils/imports.jsx";
export const array = [
  {
    heading: "Web Development",
    des: "At Squareboat, we design and develop websites and web apps that can make sure you’re seen and heard in the right circles.",
    img: coding,
    techList: [
      {
        header: "Backend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
      {
        header: "Frontend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
    ],
  },
  {
    heading: "App Development",
    des: "At Squareboat, we design and develop websites and web apps that can make sure you’re seen and heard in the right circles.",
    img: coding,
    techList: [
      {
        header: "Backend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
      {
        header: "Frontend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
    ],
  },
  {
    heading: "Digital Marketing",
    des: "At Squareboat, we design and develop websites and web apps that can make sure you’re seen and heard in the right circles.",
    img: coding,
    techList: [
      {
        header: "Backend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
      {
        header: "Frontend Development",
        img: Front,
        skills: [
          {
            img: Angular,
            name: "Angular",
          },
          {
            img: React,
            name: "React.Js",
          },
        ],
      },
    ],
  },
];
